import React from "react";

/**
 * OpenTable embed.
 * Reads restaurant ID from REACT_APP_OPENTABLE_RID.
 * When not configured, calls children({ configured:false }) so the parent can render its own form.
 * When configured, renders the OpenTable iframe in the same grid slot.
 */
export default function OpenTableEmbed({ children, className = "lg:col-span-3" }) {
  const rid = process.env.REACT_APP_OPENTABLE_RID;

  if (!rid) {
    return typeof children === "function" ? children({ configured: false }) : null;
  }

  const src = `https://www.opentable.com/widget/reservation/loader?rid=${encodeURIComponent(rid)}&type=standard&theme=tall&overlay=false&domain=com&lang=en-US&newtab=false`;

  return (
    <div className={`surface overflow-hidden ${className}`} data-testid="opentable-embed">
      <iframe
        title="OpenTable Reservations"
        src={src}
        width="100%" height="540"
        frameBorder="0"
        style={{ border: 0, background: "transparent" }}
      />
    </div>
  );
}
